/**
 * 刷新客户端接口
 * 目前适用于随手记
 */
import useragent from '@common/useragent'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'
import { compare } from './version'

export default () => {
  /**
   * 说明：开户、充值、提现，这三个场景，安卓旧版本调requestRefreshOpenApi，iOS调requestOpenApi。
   * 新版本开始，统一调refreshWalletEntrance，新版本是【iOS：10.9.9，安卓：10.5.1.0 】
   * 以后将取消 requestRefreshOpenApi模块
   */
  if (useragent.isSuishouji) {
    const featureVersion = useragent.isAndroid ? '10.5.1.0' : '10.9.9'
    if (compare(featureVersion)) {
      call(uriSuishouji('refreshWalletEntrance'))
    } else if (useragent.isIOS) {
      call(uriSuishouji('requestOpenApi'))
    } else if (useragent.isAndroid) {
      call(uriSuishouji('requestRefreshOpenApi'))
    }
  } else if (useragent.isKaniu) {
    call('cardniu://app/financeWalletEntranceUpdate?opt=1')
  } else if (useragent.isSuiguanjia) {
    call(uriSuiguanjia('sgj://app/refreshAssetStatus'))
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/refreshWalletEntrance.js